module.exports = __webpack_public_path__ + "img/Love.05932239.png";